import * as fromUserPreferences from "./userpreference.reducer";
import { IState } from "../reducers";
import { IUserPreference } from "../../common/services/contracts/userpreference.contract";

export const getEntireUserPreference = () => (store: IState): fromUserPreferences.IUserPreferenceState => store.userPreference ? store.userPreference : fromUserPreferences.initialState;
export const getUserPreference = () => (store: IState): IUserPreference => getEntireUserPreference()(store).userPreference;
export const getUserPreferenceLoading = () => (store: IState): boolean => getEntireUserPreference()(store).loading;
export const getUserPreferenceLoaded = () => (store: IState): boolean => getEntireUserPreference()(store).loaded;
export const getUserPreferenceError = () => (store: IState): string => getEntireUserPreference()(store).error;
